import React, { memo } from 'react';
import lmsCourseStyles from "../../../assets/css/LMSCourse.module.css";
import {format} from "date-fns";
import {getUTCDateFromServerDate} from "../../../utils/dateUtils";
import CardLink from "../CardLink";
import {IconAngleRight, IconCheckmarkCircle, IconSlashCircle} from "@ace/react-icons";
import buttonStyles from "../../../assets/css/Button.module.css";
import { courseHelpers } from 'Components/Card/Partials/Partials.Course';

export const LMSCourseCardComponent = ({course}) => {
    const CompletionSubHeader = () => (<p className={lmsCourseStyles.completion}>Completed {format(getUTCDateFromServerDate(course.CompletionDate), 'MMMM d, yyyy')}</p>);
    const StatusHeader = () => (course.Passed ? <PassedStatus /> : <FailedStatus />);

    return (
        <div className={lmsCourseStyles.lmsCourse}>
            <div className={lmsCourseStyles.titleWrap}>
                <h4 className={lmsCourseStyles.title}>
                    <span>{course.HeaderText}</span>
                </h4>
                {course.Taken && <StatusHeader />}
            </div>
            {course.CompletionDate && <CompletionSubHeader />}
            <CardLink
                linkText={course.ActionLink.CardLinkText}
                linkIcon={<IconAngleRight />}
                linkUrl={course.ActionLink.CardLinkUri}
                target="_blank"
                className={`${courseHelpers.cardLinkBtnClass(course)} ${buttonStyles.micro}`}
            />
        </div>
    )
}

const PassedStatus = memo(() => (
    <span className={lmsCourseStyles.status + " " + lmsCourseStyles.passed}>
        <IconCheckmarkCircle className={lmsCourseStyles.statusIcon} fill="#4ABFAD" />
        Passed!
    </span>
));

const FailedStatus = memo(() => (
    <span className={lmsCourseStyles.status + " " + lmsCourseStyles.failed}>
        <IconSlashCircle className={lmsCourseStyles.statusIcon} fill="#E29907" />
        Did not pass
    </span>
));